<template>
  <div>
    <LoginForm @onSubmit="handleLogin" />
    <div v-if="error" class="text-red">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import LoginForm from "@/components/molecules/LoginForm.vue";
import authApi from "@/api/auth";

export default defineComponent({
  name: "LoginView",
  components: {
    LoginForm,
  },
  data() {
    return {
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      error: null,
      success: false,
      authInfo: {
        username: "",
        password: "",
      },
      isSessionActive: false,
      loginTimestamp: "",
      permissions: [],
    };
  },
  methods: {
    async handleLogin(authInfo) {
      this.authInfo = authInfo;
      try {
        const response = await authApi.login(authInfo);
        console.log("response: ", response)

        if (response.authInfo) {
          this.success = true;
          const authUserId = response.authInfo.auth_user_id;
          const sessionKey = response.authInfo.session_key;
          this.error = null;
          localStorage.setItem("authUserId", authUserId);
          localStorage.setItem("sessionKey", sessionKey);
          console.log("authInfo: ", this.authInfo);
        } else {
          this.error =
            "ログインに失敗しました。ユーザーIDまたはパスワードが正しくありません。";
        }
      } catch (err) {
        this.error =
          err.response?.data?.message ||
          err.message ||
          "不明なエラーが発生しました。";
        this.success = false;
      }
    },
  },
});
</script>

<style>
.text-red {
  color: red;
}
</style>
